import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { PersonalNestApi } from "../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../providers/global-service/global-service";
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";
import { ResponseAddDto, ResponseSaveDto, ResponseDeleteDto } from "../../../shared/nestjs/gd-integrated/dto/reference.dto";
import { OrgactivSf6Api } from "../../../shared/nestjs/gd-integrated/services/orgactiv-sf6.api";


@Injectable()
export class ProfileOrgactivBloc {
  constructor(
    public personalApi: PersonalNestApi,    
    public globalService: GlobalServiceProvider,
    public nestResponse: NestResponsesProvider,		
    public orgactivSf6Api: OrgactivSf6Api
   ) {

   }

	add(data): Observable<ResponseAddDto> {
		return this.orgactivSf6Api.add(data);
	}

	save(data): Observable<ResponseSaveDto> {
		return this.orgactivSf6Api.save(data);
	}

	delete(data): Observable<ResponseDeleteDto> {
		return this.orgactivSf6Api.delete(data);
  }

  getPersonal(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.personalApi.getPersonal(payload).subscribe(
        async (result) => {
          console.log('BLOC | getPersonal', result)
          let resultData = await this.globalService.convertObjToCamelCase(result.data);
          resolve(resultData);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  listing(payload): Observable<any> {
		return this.orgactivSf6Api.listing(payload.empId);
  }
  
  country(): Observable<any> {
    console.log('BLOC | country')
		return this.orgactivSf6Api.country();
  }
  
  state(countryId): Observable<any> {
    console.log('BLOC | state', countryId)
		return this.orgactivSf6Api.state(countryId);
  }
  
  city(stateId): Observable<any> {
    console.log('BLOC | city', stateId)
		return this.orgactivSf6Api.city(stateId);
	}
}



// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-orgactiv.bloc.ts